module.exports = __webpack_public_path__ + "static/media/sucursal-background.74262eca.png";